<script setup lang="ts">
    import { COLOR_PALETTE } from '@/utils/colorPalette';

    const emit = defineEmits<{
        close: [];
    }>();
    const model = defineModel<string>({ default: '#000000' });

    function switchColor(color: string) {
        model.value = color;
        emit('close');
    }
</script>

<template>
    <div class="pb-6 pt-2">
        <div class="mx-auto max-w-md rounded-md p-2 sm:p-4">
            <div class="grid gap-2 sm:gap-3">
                <div
                    v-for="(row, rowIndex) in COLOR_PALETTE"
                    :key="'row-' + rowIndex"
                    class="grid grid-cols-7 gap-2 md:gap-3"
                >
                    <button
                        v-for="(color, colIndex) in row"
                        :key="'cell-' + rowIndex + '-' + colIndex"
                        class="aspect-square rounded-full shadow-md transition-transform duration-150 ease-in-out hover:scale-110 focus:outline-none active:scale-125"
                        :style="{ backgroundColor: color }"
                        @click="switchColor(color)"
                    >
                        <span class="sr-only"> {{ $t('select_color') }} {{ color }} </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
